import styled from "styled-components";

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
    max-width: 842px;
    margin: 0 auto;

    @media (min-width: 850px){
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
    }
  }
`;

export const CardBox = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 48px;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

   @media (min-width: 850px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-auto-flow: row dense;
    /* padrão cíclico: 2 col, 3 col, 3 col, 2 col */
    & > :nth-child(4n + 1) { grid-column: span 2; }
    & > :nth-child(4n + 2) { grid-column: span 3; }
    & > :nth-child(4n + 3) { grid-column: span 3; }
    & > :nth-child(4n + 4) { grid-column: span 2; }
  }

`;

export const CardButton = styled.button`
  position: relative;        /* para o ::before posicionar dentro */
  padding: 0;
  border-radius: 16px;
  height: 274px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  outline: none;
  cursor: pointer;

  /* o bg vai no ::before para poder dar zoom sem afetar layout */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-image: ${({ $bg }) => ($bg ? `url(${$bg})` : "none")};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transform: scale(1);
    transition: transform 260ms ease, filter 260ms ease;
    will-change: transform;
  }

  /* hover/focus: zoom suave sem empurrar outros cards */
  &:hover::before,
  &:focus-visible::before {
    transform: scale(1.1);
    filter: brightness(1.02);
  }

  @media (min-width: 850px){
    height: 514px;
  }

  /* acessibilidade: respeita preferência de menos animação */
  @media (prefers-reduced-motion: reduce) {
    &::before { transition: none; }
  }
`;
